import { createContext, useContext, ReactNode } from "react";
import { Users } from "../api/models/user.models";
import useAdminCompanies from "../hooks/useAdminCompanies";
import { Company } from "../api/models/companies.models";
import useAdmins from "../hooks/useAdmins";

type AdminDataContextProps = {
  users?: Users[];
  isLoadingUsers: boolean;
  companies?: Company[];
  isLoadingCompanies?: boolean;
};

export const AdminDataContext = createContext<AdminDataContextProps>({
  users: undefined,
  isLoadingUsers: false,
});

type AdminDataProviderProps = {
  children: ReactNode;
  isAdmin?: boolean;
};

export const AdminDataProvider = ({
  children,
  isAdmin = false,
}: AdminDataProviderProps) => {
  const { admins, adminsIsLoading } = useAdmins({ isAdmin: isAdmin || false });

  const { companies, isLoadingCompanies } = useAdminCompanies({
    includeOrganizations: true,
    enabled: isAdmin,
  });

  const value: AdminDataContextProps = {
    users: isAdmin ? admins : undefined,
    isLoadingUsers: isAdmin ? adminsIsLoading : false,
    companies: isAdmin ? companies : undefined,
    isLoadingCompanies: isAdmin ? isLoadingCompanies : undefined,
  };

  return (
    <AdminDataContext.Provider value={value}>
      {children}
    </AdminDataContext.Provider>
  );
};

export const useAdminDataContext = () => useContext(AdminDataContext);
